import miniToastr from 'mini-toastr';

miniToastr.setIcon('error', 'i', {
    'class': 'fa fa-times'
});
miniToastr.setIcon('warn', 'i', {
    'class': 'fa fa-exclamation-triangle'
});
miniToastr.setIcon('info', 'i', {
    'class': 'fa fa-info-circle'
});
miniToastr.setIcon('success', 'i', {
    'class': 'fa fa-check-circle'
});


// WEBPACK FOOTER //
// ./src/components/global/miscellaneous/notificationIcons.js